import { IonBreadcrumb, IonBreadcrumbs, IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonMenuButton, IonModal, IonPage, IonPopover, IonRouterOutlet, IonSearchbar, IonTitle, IonToolbar } from "@ionic/react";

import { add, ellipsisHorizontal, home } from 'ionicons/icons';
import { useState, useRef, useEffect } from 'react';
import ProgressBar from '@/components/ProgressBar';
import backend from '@/controllers/backend'
import { get } from '@/controllers/preferences'
import { Route, useHistory, useParams } from "react-router";

import UserBooks from './UserBooks'
import { OverlayEventDetail } from "@ionic/core";
import FolderList from "./FolderList";
import DocumentList from "./DocumentList";

const name = "Books"
const UserBooksPage: React.FC = () => {
    const uploadRef = useRef<HTMLElement>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const menuRef = useRef<HTMLIonPopoverElement>(null);
    const startedRef = useRef(false);

    const [uploadProgress, setUploadProgress] = useState<number | null>(null);
    const [isUploading, setIsUploading] = useState(false);
    const [fileName, setFileName] = useState<string | null>(null);
    const [userId, setUserId] = useState(null)
    const [documents, setDocuments] = useState([])
    const [suggested, setSuggested] = useState([])

    const path = useParams()[0];
    const params = useParams();

    const later = async () => {
        const dir = await backend.dir_get(params.folder_id)
        setFolder(dir.dir)
        setParents(dir.breadcrumbs)
        setSubfolders(dir.subfolders)
        setUserId(await get("user_id"))
        setDocuments(dir.documents)

        console.log(await backend.docs(path))
        setDocs(await backend.docs(path)) // TODO: dir_get should give docs
    }

    useEffect(() => {
        //if (startedRef.current) return;
        //startedRef.current = true;
        later()
    }, [params])

    const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;
        for (const file of files) {
            
            // Set uploading state
            setIsUploading(true);
            setFileName(`Uploading: ${file.name}`);
            setUploadProgress(0);

            // UI update
            menuRef.current?.dismiss();
            setTimeout(() => {
                uploadRef.current?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
            }, 40);
            
            try {
                await backend.upload_doc(file, (progress) => {
                    setUploadProgress(progress);
                }, params.folder_id);
                
                // Start pulling TOC
                // TODO: move to server side?
                // NOTE: no await so we don't wait till toc is done
                //backend.toc(await get("user_id"), file.name, path);

                // Refresh the docs list after upload
                later();
            } catch (error) {
                console.error("Upload failed:", error);
            } finally {
                // Reset uploading state
                setIsUploading(false);
                setUploadProgress(null);
                setFileName(null);
            }
        }
    };

    const handleUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const history = useHistory()
    const newFolderModalRef = useRef<HTMLIonModalElement>(null)
    const newFolderInputRef = useRef<HTMLIonInputElement>(null);
    const submitNewFolder = async (event: CustomEvent<OverlayEventDetail>) => {
        if (event.detail.role === 'confirm') {
            const folderName = newFolderInputRef.current?.value
            if (!folderName) return;
            console.log(params)
            const newDir = await backend.dir_create(''+folderName, params.folder_id)
            history.push(`/folders/${newDir.id}/${newDir.name}`)
        }
    }

    const folderNameRef = useRef<HTMLIonInputElement>(null)

    const [parents, setParents] = useState([])
    const [folder, setFolder] = useState(null)
    const [subfolders, setSubfolders] = useState([])

    const setFolderName = async () => {
        console.log("change")
        const value = "" + folderNameRef.current!.value!
        console.log(value)
        const dir = await backend.dir_change(folder.id, value)
        setFolder(dir.dir)
        setParents(dir.breadcrumbs)
        setSubfolders(dir.subfolders)
        history.push(`/folders/${dir.dir.id}/${dir.dir.name}`)
    }

    const foldersMenuRef = useRef<HTMLIonPopoverElement>(null);

    return (
    <IonPage>
        <IonHeader className="shadow-none">
            <IonToolbar className="shadow-md">
                <IonButtons slot="start">
                    <IonMenuButton />
                </IonButtons>
                <IonSearchbar style={{'--box-shadow': 'none'}} placeholder="Documents" debounce={100}></IonSearchbar>
                <IonButtons slot="end" className="mr-2">
                    <IonButton onClick={(e) => {menuRef.current!.present(e)}} strong={true}>
                        <IonIcon icon={add} />
                    </IonButton>
                    <IonPopover ref={menuRef} reference="event">
                        <IonContent class="">
                            <IonList>
                                <IonItem button={true} onClick={() => {
                                    handleUploadClick();
                                }}>Upload Documents</IonItem>
                                <IonItem button={true} onClick={() => {
                                    handleUploadClick();
                                }}>Link YouTube video/playlist</IonItem>
                                <IonItem button={true} onClick={() => {
                                    handleUploadClick();
                                }}>Link Web Page</IonItem>
                                <IonItem
                                    button
                                    // routerLink={`/folders/${path ? path + "/" : ""}new_folder`}
                                    onClick={() => {
                                        menuRef.current?.dismiss()
                                        newFolderModalRef.current?.present()
                                        //newFolderInputRef.current?.setFocus()
                                        setTimeout(() => newFolderInputRef.current?.setFocus(), 100)
                                    }}
                                    //id="open-modal"
                                >New Folder</IonItem>
                            </IonList>
                        </IonContent>
                    </IonPopover>
                </IonButtons>
            </IonToolbar>
        </IonHeader>

        <IonModal style={{'--height': '10em'}} ref={newFolderModalRef} onWillDismiss={submitNewFolder}>
          <IonHeader>
            <IonToolbar>
              <IonButtons slot="start">
                <IonButton onClick={() => newFolderModalRef.current?.dismiss()}>Cancel</IonButton>
              </IonButtons>
              <IonTitle>Create New Folder</IonTitle>
              <IonButtons slot="end">
                <IonButton strong={true} onClick={() => newFolderModalRef.current?.dismiss(null, 'confirm')}>
                  Confirm
                </IonButton>
              </IonButtons>
            </IonToolbar>
          </IonHeader>
          <IonContent className="ion-padding">
            <IonItem>
              <IonInput
                label="Enter folder name"
                labelPlacement="stacked"
                ref={newFolderInputRef}
                type="text"
                placeholder="Folder name"
                onKeyDown={(e) => { if (e.key === 'Enter') {
                    e.preventDefault()
                    newFolderModalRef.current?.dismiss(null, 'confirm')
                } }}
              />
            </IonItem>
          </IonContent>
        </IonModal>

        <IonContent fullscreen>
            <IonHeader collapse="condense">
                <IonToolbar>
                    <IonTitle size="large">{name}</IonTitle>
                </IonToolbar>
            </IonHeader>

    <div ref={uploadRef} className={`max-w-md mx-auto shadow-md rounded-xl overflow-hidden md:max-w-2xl ${isUploading ? 'pb-6' : ''}`}> 
        <input 
            type="file" 
            accept=".pdf,application/pdf" 
            onChange={handleFileChange} 
            ref={fileInputRef}
            className="hidden"
            multiple
        />

        <ProgressBar progress={uploadProgress} isLoading={isUploading} title={fileName} subtitle="Please wait while your file is being uploaded..." />
    </div>

    {folder && (
    <IonItem color="light">
        <IonBreadcrumbs>
            <IonBreadcrumb routerLink="/">
                <IonIcon slot="start" icon={home}></IonIcon>
                Home
            </IonBreadcrumb>
            {parents.map((p, idx) => {return (
                <IonBreadcrumb key={idx} routerLink={`/folders/${p.id}/${p.name}`}>
                    {p.name}
                </IonBreadcrumb>
            )})}
            <IonBreadcrumb>
                <IonInput ref={folderNameRef} value={folder.name} onIonChange={setFolderName}
                  onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); setFolderName() } }}
                />
            </IonBreadcrumb>
        </IonBreadcrumbs>
        <div slot="end">
            <IonButton fill="clear" onClick={(e) => {foldersMenuRef.current!.present(e)}}>
                <IonIcon slot="icon-only" icon={ellipsisHorizontal}></IonIcon>
            </IonButton>
            <IonPopover ref={foldersMenuRef} reference="event">
                <IonContent class="">
                    <IonList>
                        <IonItem button={true}>Share</IonItem>
                        <IonItem button={true} onClick={async () => {
                            await backend.dir_delete(folder.id)
                            foldersMenuRef.current!.dismiss()
                            if (parents.length > 0) {
                                const parent = parents[parents.length - 1]
                                history.push(`/folders/${parent.id}/${parent.name}`)
                            } else {
                                history.push(`/docs/`)
                            }
                        }}>Delete</IonItem>
                    </IonList>
                </IonContent>
            </IonPopover>
        </div>
    </IonItem>
    )}
    {subfolders.length > 0 && (<>
    <IonItem color="light">
        <IonLabel>Your Folders</IonLabel>
    </IonItem>
    <FolderList folders={subfolders} repo_id={userId} />
    </>)}
    {documents.length > 0 && (<>
    <IonItem color="light">
        <IonLabel>Documents</IonLabel>
    </IonItem>
    <DocumentList title="Documents" subtitle="" docs={documents} repo_id={userId} />
    </>)}
    {suggested.length > 0 && (<>
    <IonItem color="light">
        <IonLabel>Suggested Books</IonLabel>
    </IonItem>
    <DocumentList title="Public Books" subtitle="" docs={suggested} repo_id="public" />
    </>)}
    </IonContent>
    </IonPage>
    )
}

export default UserBooksPage;